import 'css-chunksrc/feature/provision/ProvisionItemCta.module.scss';export default {
  "root": "ProvisionItemCta_root"
};